import { SpinResponse } from '@cgs/data-access';
import { RequestState } from './request_state';

export class SpinRequestState<TResponse extends SpinResponse> extends RequestState<TResponse> {
  protected doRequest(): Promise<TResponse> {
    return this.gameDataService.spin() as Promise<TResponse>;
  }
}
